import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var UpDeviceBaseInfo = function UpDeviceBaseInfo() {
    _classCallCheck(this, UpDeviceBaseInfo);

    this.protocol = '';
    this.parentId = '';
    this.subDevNo = '';
    this.deviceId = '';
    this.typeId = '';
    this.typeName = '';
    this.typeCode = '';
    this.model = '';
    this.prodNo = '';
};
export var BasicInfo = function BasicInfo() {
    _classCallCheck(this, BasicInfo);

    this.dispName = '';
    this.room = '';
    this.roomId = '';
    this.online = false;
    this.deviceImageUrl = '';
    this.subDeviceIds = '';
    this.parentId = '';
    this.deviceRole = '';
    this.deviceRoleType = '';
    this.devFloorId = '';
    this.devFloorOrderId = '';
    this.devFloorName = '';
    this.apptypeName = '';
    this.deviceGroupId = '';
    this.deviceGroupType = '';
};
export var ProductInfo = function ProductInfo() {
    _classCallCheck(this, ProductInfo);

    this.barcode = '';
    this.brand = '';
    this.accessType = '';
    this.configType = '';
    this.image1 = '';
    this.image2 = '';
    this.bindType = '';
    this.comunicationMode = '';
};
export var Relation = function Relation() {
    _classCallCheck(this, Relation);

    this.ownerId = '';
    this.familyId = '';
    this.ucUserId = '';
};
export var Permission = function Permission() {
    _classCallCheck(this, Permission);

    this.authType = '';
    this.ctrl = false;
    this.edit = false;
    this.view = false;
};
export var Alarm = function Alarm() {
    _classCallCheck(this, Alarm);

    this.name = '';
    this.value = '';
    this.time = '';
    this.message = '';
    this.clear = false;
};
export var DeviceModel = function DeviceModel() {
    _classCallCheck(this, DeviceModel);

    this.baseInfo = new UpDeviceBaseInfo();
    this.connection = 'OFFLINE';
    this.controlState = '';
    this.deviceOnlineStatus = '';
    this.sleepState = '';
    this.attributes = new Map();
    this.cautions = [];
    this.deviceNetworkLevel = '';
    this.onlineStateV2 = '';
    this.bleState = '';
    this.subDevList = [];
    this.extras = {
        basic: new BasicInfo(),
        product: new ProductInfo(),
        relation: new Relation(),
        permission: new Permission()
    };
};
export var BatchAttachModel = function BatchAttachModel() {
    _classCallCheck(this, BatchAttachModel);

    this.attributeNames = [];
};
export var SimplifyDataModel = function SimplifyDataModel() {
    _classCallCheck(this, SimplifyDataModel);

    this.connection = 'OFFLINE';
    this.attributes = new Map();
    this.cautions = [];
    this.engineAttributes = [];
    this.engineCautions = [];
};
export var NetWorkQualityModel = function NetWorkQualityModel() {
    _classCallCheck(this, NetWorkQualityModel);

    this.machineId = '';
    this.isOnLine = false;
    this.statusLastChangeTime = '';
    this.netType = '';
    this.ssid = '';
    this.rssi = '';
    this.prssi = '';
    this.signalLevel = '';
    this.ilostRatio = '';
    this.its = '';
    this.lanIP = '';
    this.moduleVersion = '';
};
export var DeviceModelMixLogicAttrs = function DeviceModelMixLogicAttrs() {
    _classCallCheck(this, DeviceModelMixLogicAttrs);

    this.baseInfo = new UpDeviceBaseInfo();
    this.connection = 'OFFLINE';
    this.controlState = '';
    this.deviceOnlineStatus = '';
    this.attributes = new Map();
    this.cautions = [];
    this.onlineStateV2 = '';
    this.deviceNetworkLevel = '';
    this.sleepState = '';
    this.bleState = '';
    this.engineAttributes = [];
    this.engineCautions = [];
    this.subDevList = [];
    this.extras = {
        basic: new BasicInfo(),
        product: new ProductInfo(),
        relation: new Relation(),
        permission: new Permission()
    };
};
export var FOTAInfo = function FOTAInfo() {
    _classCallCheck(this, FOTAInfo);
};
export var FOTAStatus = function FOTAStatus() {
    _classCallCheck(this, FOTAStatus);
};
export var BindProgress;
(function (BindProgress) {
    BindProgress["CONNECT_DEVICE"] = '\u8FDE\u63A5\u8BBE\u5907';
    BindProgress["SEND_CONFIG_INFO"] = '\u53D1\u9001\u914D\u7F6E\u4FE1\u606F';
    BindProgress["VERIFICATION"] = '\u5F00\u59CB\u6821\u9A8C';
    BindProgress["BIND_DEVICE"] = '\u7ED1\u5B9A\u8BBE\u5907';
    BindProgress["START_NETWORKING_MODE"] = '\u5F00\u59CB\u8FDB\u5165\u7EC4\u7F51\u6A21\u5F0F';
    BindProgress["START_NETWORKING"] = '\u5F00\u59CB\u7EC4\u7F51';
    BindProgress["START_BIND_SLAVE_DEVICE"] = '\u5F00\u59CB\u7ED1\u5B9A\u5B50\u673A';
    BindProgress["BIND_DEVICE_SUCCESS"] = '\u7ED1\u5B9A\u8BBE\u5907\u6210\u529F';
    BindProgress["BIND_PROGRESS_CONNECT_FAILURE"] = '\u8BBE\u5907\u8FDE\u63A5\u8DEF\u7531\u5931\u8D25';
    BindProgress["BIND_DEVICE_FAILURE"] = '\u8BBE\u5907\u7ED1\u5B9A\u5931\u8D25';
})(BindProgress || (BindProgress = {}));
export var UpDeviceChangedListeners = function UpDeviceChangedListeners() {
    _classCallCheck(this, UpDeviceChangedListeners);
};
export var UpOneKeyConnectScannerListener = function UpOneKeyConnectScannerListener() {
    _classCallCheck(this, UpOneKeyConnectScannerListener);
};
export var UpOneKeyConnectBindListener = function UpOneKeyConnectBindListener() {
    _classCallCheck(this, UpOneKeyConnectBindListener);
};
export var DeviceCommand = function DeviceCommand() {
    _classCallCheck(this, DeviceCommand);
};
export var PlaybackItem = function PlaybackItem() {
    _classCallCheck(this, PlaybackItem);
};